import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { setTenantModule } from '@/api/modules/modulesApi';
import type { ModuleState } from '@/api/modules/modulesApi.types';
import { buildTenantModulesQueryKey } from '@/constants/queryKeys';

interface SetTenantModuleVariables {
  moduleKey: string;
  isEnabled: boolean;
}

export function useSetTenantModuleMutation(
  tenantId: string
): UseMutationResult<ModuleState, Error, SetTenantModuleVariables> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function toggleModule(variables: SetTenantModuleVariables) {
      return setTenantModule(tenantId, variables.moduleKey, variables.isEnabled);
    },
    onSuccess: function invalidateModules() {
      queryClient.invalidateQueries({ queryKey: buildTenantModulesQueryKey(tenantId) });
    },
  });
}
